module.exports = __webpack_public_path__ + "static/media/login_text1.5fc18032.png";